import { createRoot, hydrateRoot } from "react-dom/client";
import App from "./App";

// Suppress React DevTools message in production
if (typeof window !== 'undefined') {
  (window as any).__REACT_DEVTOOLS_GLOBAL_HOOK__ = (window as any).__REACT_DEVTOOLS_GLOBAL_HOOK__ || {};
  (window as any).__REACT_DEVTOOLS_GLOBAL_HOOK__.isDisabled = true;
}

const root = document.getElementById("root")!;
const app = <App />;

// The server always injects pre-rendered markup into #root for SEO (both in
// dev via server/vite.ts and in prod via the built static server), so hydrate
// whenever that markup is present instead of gating on PROD. Using
// createRoot() on a node that already has server-rendered children wipes it
// and remounts a moment later, causing a visible flash on every page load.
if (root.hasChildNodes()) {
  hydrateRoot(root, app);
} else {
  createRoot(root).render(app);
}
